export const config = {
  dev: {
    // baseUrl: 'http://localhost:8085',
    baseUrl: 'https://apim-dev-uswest2-seesor-svc-v3.azure-api.net/v3',
    // baseUrl: 'http://development.seesor.net/web',
    featureFlags: {
      offlineManagement: { mobileOnly: false },
      reporting: { webOnly: true },
      pages: {
        inspecting: true,
        planning: true,
        correctiveActions: true,
        reporting: true,
        userPreferences: true,
        moduleSettings: true,
        userManagement: true,
        enterpriseManagement: true,
      },
    },
  },
  staging: {
    baseUrl: 'https://apim-dev-uswest2-seesor-svc-v3.azure-api.net/v3',
    featureFlags: {
      offlineManagement: { mobileOnly: true },
      reporting: { webOnly: true },
      pages: {
        inspecting: false,
        planning: false,
        correctiveActions: false,
        reporting: false,
        userPreferences: false,
        moduleSettings: false,
        userManagement: false,
        enterpriseManagement: false,
      },
    },
  },
  prod: {
    baseUrl: 'https://ascgroup.seesor.net/web',
    featureFlags: {
      offlineManagement: { mobileOnly: true },
      reporting: { webOnly: true },
      pages: {
        inspecting: false,
        planning: false,
        correctiveActions: false,
        reporting: false,
        userPreferences: false,
        moduleSettings: false,
        userManagement: false,
        enterpriseManagement: false,
      },
    },
  },
  dateFormat: 'YYYY-MMM-DD',
  dateTimeFormat: 'YYYY-MMM-DD h:mm a',
  timeFormat: 'h:mm a',
  api: {
    timeout: 30000, // in milliseconds
    maxRetries: 0,
    retryDelay: 1000, // in milliseconds
    tokenRefreshInterval: 300, // in seconds
  },
  Inspecting : {
    pastDaysToShow: 3000, // Number of past days to include in inspection results
    futureDaysToShow: 90, // Number of future days to include in inspection results
    autoSaveInterval: 30000, // in milliseconds
  },
  transitionTime: 300, // in milliseconds
  emailAddressRegex: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i,
  androidAppLink: 'https://play.google.com/store/apps/details?id=com.phoenix_editor&hl=en_CA',
  iosAppLink: 'https://apps.apple.com/us/app/seesor-offline/id1632993422',
  // Slug-to-backend mapping used for mobile tenant discovery
  tenants: {
    ascgroup: { name: 'ASC Group', baseUrl: 'https://ascgroup.seesor.net/web' },
    ascgroupdev: { name: 'ASC Group Dev', baseUrl: 'http://development.seesor.net/web' },
    ascgroupqa: { name: 'ASC Group QA', baseUrl: 'https://apim-dev-uswest2-seesor-svc-v3.azure-api.net/v3' },
  } as Record<string, { name: string; baseUrl: string }>,
};
 